import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Box } from '../../Box/Box.js';
import { InputContainerStyled } from '../Common/FormField.styled.js';
import { dropdownInteractiveState, inputInteractiveState } from '../Common/inputInteractiveState.js';
import { Typography } from '../../Typography/Typography.js';
import { useExperimentContext } from '../../../contexts/session/Experiment.js';
import { useThemeContext } from '../../../contexts/session/Theme.js';

var _excluded = ["children", "showLabel", "component", "state", "label", "intent", "helperText", "helperTextId", "helperTextRole", "labelId", "helperTextData"];
var borderColorToken = {
  default: 'base.default',
  success: 'feedback.positive.strong',
  error: 'feedback.negative.strong',
  disabled: 'deprecated.neutral.disabled-1'
};
var labelColorToken = {
  default: 'base.subtle',
  success: 'feedback.positive',
  error: 'feedback.negative',
  disabled: 'base.disabled'
};
var InputFrame = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    showLabel = _ref.showLabel,
    component = _ref.component,
    state = _ref.state,
    label = _ref.label,
    intent = _ref.intent,
    helperText = _ref.helperText,
    helperTextId = _ref.helperTextId,
    helperTextRole = _ref.helperTextRole,
    labelId = _ref.labelId,
    _ref$helperTextData = _ref.helperTextData,
    helperTextData = _ref$helperTextData === void 0 ? {} : _ref$helperTextData,
    rest = _objectWithoutProperties(_ref, _excluded);
  var experiments = useExperimentContext();
  var theme = useThemeContext();
  var enabled = state !== 'disabled';
  var interactiveState = component === 'dropdown' ? dropdownInteractiveState(experiments, theme, enabled) : inputInteractiveState(experiments, theme, enabled);
  var borderColor = borderColorToken[enabled ? intent || 'default' : 'disabled'];
  var textColor = labelColorToken[enabled ? intent || 'default' : 'disabled'];
  var helperTextElement = helperText && /*#__PURE__*/React.createElement(Typography, _extends({}, helperTextData, {
    id: helperTextId,
    display: "inline-block",
    tag: "span",
    variant: "caption-default",
    mt: "4",
    ms: "16",
    textColor: textColor,
    role: helperTextRole
  }), helperText);
  return /*#__PURE__*/React.createElement(InputContainerStyled, _extends({
    ref: ref,
    $showLabel: showLabel,
    $interactiveState: interactiveState,
    "aria-disabled": !enabled
  }, rest), /*#__PURE__*/React.createElement(Box, {
    pt: "12",
    display: "flex",
    position: "relative"
  }, /*#__PURE__*/React.createElement(Box, {
    as: "fieldset",
    position: "absolute",
    m: "0",
    p: "0",
    ps: "12",
    borderWidth: "1",
    borderColor: borderColor,
    borderStyle: "solid",
    borderRadius: "8",
    backgroundColor: enabled ? 'base.surface' : 'deprecated.neutral.disabled-1'
  }, /*#__PURE__*/React.createElement("legend", null, /*#__PURE__*/React.createElement(Typography, {
    id: labelId,
    mx: "4",
    tag: "span",
    variant: "caption-default",
    textColor: textColor
  }, label))), children), helperTextElement);
});
var InputFrameMemo = /*#__PURE__*/React.memo(InputFrame);
InputFrameMemo.displayName = 'InputFrame';

export { InputFrameMemo as InputFrame };
//# sourceMappingURL=InputFrame.js.map
